export const getMapViewBounds = (map) => {
  const bounds = map.getBounds();
  const southWest = {
    lat: bounds.getSouthWest().lat(),
    lng: bounds.getSouthWest().lng(),
  };
  const northEast = {
    lat: bounds.getNorthEast().lat(),
    lng: bounds.getNorthEast().lng(),
  };

  const sw = { lat: southWest.lat, lng: southWest.lng };
  const ne = { lat: northEast.lat, lng: northEast.lng };
  const nw = { lat: northEast.lat, lng: southWest.lng };
  const se = { lat: southWest.lat, lng: northEast.lng };

  return { sw, ne, nw, se };
};
